import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiGetJson } from '../../lib/apiClient'
import { extractSiteStatsFromApiResponse, type SiteStats } from '../../modules/products/utils/siteStats'

export default function CustomerRightSideBarSystemInfo() {
  const [stats, setStats] = useState<SiteStats | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const renderValue = (value: number | null) => {
    if (loading) return '...'
    if (error) return '--'
    return `${Number(value || 0).toLocaleString('vi-VN')}+`
  }

  useEffect(() => {
    let alive = true
    const load = async () => {
      try {
        setLoading(true)
        setError(null)
        const resp = await apiGetJson<any>('/api/site-stats')
        const parsed = extractSiteStatsFromApiResponse(resp)
        if (!alive) return
        setStats(parsed)
      } catch (e: any) {
        if (!alive) return
        setStats(null)
        setError(typeof e?.message === 'string' ? e.message : 'Không thể tải thống kê site')
      } finally {
        if (alive) setLoading(false)
      }
    }
    void load()
    return () => { alive = false }
  }, [])

  return (
    <div className="px-4 pb-4">
      <div className="rounded-2xl border border-slate-200/80 dark:border-white/10 bg-slate-50/50 dark:bg-white/5 p-3">
        <div className="flex items-center justify-between gap-2 mb-3">
          <div className="text-xs font-black tracking-wide text-slate-900 dark:text-white/90">Hệ thống</div>
          <Link
            to="/policy"
            className="text-[11px] font-semibold text-amber-600 dark:text-amber-200 hover:underline"
          >
            Thông tin
          </Link>
        </div>
        <div className="space-y-2">
          <div className="rounded-xl border border-slate-200/80 dark:border-white/10 bg-white dark:bg-black/10 px-3 py-2 flex items-center justify-between gap-3 shadow-sm dark:shadow-none">
            <div className="text-[11px] font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-200">Khách hàng</div>
            <div className="text-sm font-black text-slate-900 dark:text-white/95">{renderValue(stats?.total_customers ?? null)}</div>
          </div>
          <div className="rounded-xl border border-slate-200/80 dark:border-white/10 bg-white dark:bg-black/10 px-3 py-2 flex items-center justify-between gap-3 shadow-sm dark:shadow-none">
            <div className="text-[11px] font-bold uppercase tracking-wider text-cyan-600 dark:text-cyan-200">Giao dịch</div>
            <div className="text-sm font-black text-slate-900 dark:text-white/95">{renderValue(stats?.total_completed_transactions ?? null)}</div>
          </div>
          <div className="rounded-xl border border-slate-200/80 dark:border-white/10 bg-white dark:bg-black/10 px-3 py-2 flex items-center justify-between gap-3 shadow-sm dark:shadow-none">
            <div className="text-[11px] font-bold uppercase tracking-wider text-amber-600 dark:text-amber-200">Hỗ trợ</div>
            <div className="text-sm font-black text-slate-900 dark:text-white/95">8:00-21:00</div>
          </div>
        </div>
      </div>
    </div>
  )
}
